export interface SharedWorkspaceContext {
  opportunityId: number;
  leadId: number;
  urlToken: string;
  csrfToken?: string;
}

export function getSharedWorkspaceContext():
  | SharedWorkspaceContext
  | undefined {
  return (window as any).sharedWorkspaceContext;
}
